export default 'onboarding'
